module.exports = __webpack_public_path__ + "img/mastercard.3c036285.svg";